import CarerTrackingHero from './components/CarerTrackingHero';
import Features from '../../components/sharedComponents/Features';
import HowItWorks from "../../components/sharedComponents/HowItWorks";
import WhyDtp from "../../components/sharedComponents/WhyDtp";
import Testimonials from "../../components/sharedComponents/Testimonials";
import { Helmet } from 'react-helmet';
import { carerTrackingBottomFeatures } from "./data/carerTrackingBottomFeatures";
import { carerTrackingTestimonials } from "./data/carerTrackingTestimonials";
import { carerTrackingFeaturesList } from "./data/carerTrackingFeaturesList";

const CarerTracking = () => {
    return (
        <>
            <Helmet>
                <title>Phone Location Tracking App for Carers - Device Tracker Plus</title>
                <meta name="description" content="Peace of mind for carers. Track your loved one’s location, battery level, and safety alerts without invading their privacy." />
                <link rel="canonical" href="https://www.devicetrackerplus.com/carer-tracking" />
            </Helmet>
            <CarerTrackingHero />
            <Features sectionTitle="Features Designed for Carers" features={carerTrackingFeaturesList} />
            <HowItWorks stepOne="Sign up online" stepTwo="Register device" stepThree="Start Tracking" />
            <Testimonials testimonials={carerTrackingTestimonials} />
            <WhyDtp reasons={carerTrackingBottomFeatures} title="Why Carers Trust Device Tracker Plus"/>

        </>
    );
}

export default CarerTracking;